import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { getColorForProgress } from '../../../../common/utils.tsx';

type Size = 'small' | 'medium';

type ProgressBarProps = {
	progress: number;
	size?: Size;
	testId?: string;
};

export default function ProgressBar({ testId, progress, size = 'small' }: ProgressBarProps) {
	const curProgress = Math.max(0, Math.min(progress, 100));
	const progressColor = getColorForProgress(curProgress);

	return (
		<ProgressBarWrapper size={size}>
			<Bar data-testid={testId} width={curProgress} background={progressColor} size={size} />
		</ProgressBarWrapper>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ProgressBarWrapper = styled.div<{ size: string }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	background: token('color.border', colors.N40),
	borderRadius: '3px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: (props) =>
		props.size === 'small' ? token('space.050', '4px') : token('space.100', '8px'),
	overflow: 'hidden',
	position: 'relative',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Bar = styled.span<{
	size: string;
	background: string | undefined;
	width: number;
}>({
	borderRadius: '3px',
	display: 'block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: (props) =>
		props.size === 'small' ? token('space.050', '4px') : token('space.100', '8px'),
	position: 'absolute',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	background: (props) => props.background,
	transition: 'width 0.2s',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: (props) => `${props.width}%`,
});
